/*@ngInject*/
const AuthorizationRequestInterceptorFactory = function (loginTokenRepository, clientIdRepository) {
    return {
        request: function (config) {
            let loginTokenAuthorizationHeader = loginTokenRepository.getLoginTokenAuthorizationHeader(),
                clientId = clientIdRepository.getClientId();

            if (loginTokenAuthorizationHeader) {
                if (_.isNil(config.headers.Authorization)) {
                    config.headers.Authorization = loginTokenAuthorizationHeader;
                }
            }

            if (clientId) {
                config.headers.ClientID = clientId;
            }

            return config;
        }
    };
};

angular.module('gw-um-auth')
    .factory('authorizationRequestInterceptor', AuthorizationRequestInterceptorFactory);

angular.module('gw-um-auth').config(function ($httpProvider) {
    $httpProvider.interceptors.push('authorizationRequestInterceptor');
});
